<template>
  <v-col cols="2" tile>
    <v-hover v-slot:default="{ hover }">
      <v-card light class="pa-2" :elevation="hover ? 12 : 2" @click="open">
          <v-icon large color="#aaa">mdi-plus</v-icon>
          <span  style="font-size: 0.8em !important;">  App erstellen</span>
      </v-card>
    </v-hover>
  </v-col>
</template>

<script>
import router from "@/plugins/router";

export default {
  components: {},
  data: () => ({
    
  }),
  methods: {
    async open() {
      router.push("/apps/add");
    }
  },
  created() {},

  computed: {
  }
};
</script>

<style>
</style>